import React from 'react';
import EditProductDrawer from 'screens/ProductList/components/EditProductDrawer';
import { buildCustomProductPayload } from 'screens/ProductList/helpers/formValuesToPayload';
import useInventoryProduct from 'screens/ProductList/hooks/useInventoryProduct';
import { useToast } from 'components/ToastContainer';
import { Product } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { ItemsToCreatePayload } from 'screens/ProductList/hooks/type';

export interface CreateCustomProductDrawerProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: (product: Product) => void;
  zIndex?: number;
}

const CreateCustomProductDrawer = ({
  visible,
  onClose,
  onSuccess,
  zIndex
}: CreateCustomProductDrawerProps) => {
  const { addProducts, updateError, isUpdateLoading } = useInventoryProduct();
  const toast = useToast();

  const handleSave = async (values: ItemsToCreatePayload) => {
    const payload = buildCustomProductPayload(values);
    const result = await addProducts({
      itemsToCreate: [payload]
    });

    const [, productResponseData] = result || [];
    const { data: createdProduct } = productResponseData || {};

    const product = createdProduct
      ? {
          ...createdProduct,
          averagePricePerUnitUnit: createdProduct.averagePricePerUnitUnit || '',
          stdunit: createdProduct.standardUnit,
          stdfactor: createdProduct.stdFactor,
          stdpackageunit: createdProduct.stdPackageUnit,
          productType: createdProduct.type,
          ratePerAreaUnit: '',
          ratePerTank: 0,
          totalProductUnit: '',
          totalAppliedAcreage: 0,
          targetPest: null,
          applicationMethod: '',
          custom: true,
          isCarrier: false,
          isHidden: false
        }
      : null;

    // Toast logic
    if (updateError || product === null) {
      toast.error('Unable to save changes', {
        supportButton: true,
        content:
          'An error prevented your product(s) from being added to your list. Please try again.'
      });
    } else {
      onSuccess(product);
    }
  };

  return (
    <EditProductDrawer
      handleEdit={handleSave}
      product={
        visible && {
          isNew: true,
          custom: true,
          formulation: {}
        }
      }
      visible={visible}
      onClose={onClose}
      editProductHeader="Create Custom Product"
      saveText="Create Product"
      isLoading={isUpdateLoading}
      loadingMessage="Saving custom product..."
      suppressAnimation
      zIndex={zIndex}
    />
  );
};

export default CreateCustomProductDrawer;
